import React, { PureComponent } from 'react';
import Slider from 'react-slick';
import { ExpandedLACard } from 'appSrc/components/List-Article';
import { Icon } from 'appSrc/components/UI';
import PropTypes from 'prop-types';
import style from './styles/style.module.css';

const carouselOptions = {
    infinite: false,
    variableWidth: false,
    swipeToSlide: false,
    arrows: true,
    lazyLoad: 'ondemand',
    prevArrow: <Icon source='custom' icon='carousel-prev' size={ 80 } />,
    nextArrow: <Icon source='custom' icon='carousel-next' size={ 80 } />,
    slidesToShow: 1,
    slidesToScroll: 1,
};

class ExpandedCardCarousel extends PureComponent {
    render() {
        const { carousel } = this.props;
        const content = carousel.content || [];

        return (
            <div className={ `${ style.expandedCardCarousel } ${ this.props.className }`.trim() }>
                <h2 className={ style.sectionHeading }>{ carousel.title }</h2>
                <Slider { ...carouselOptions }>
                    { content.map( ( item ) => {
                        let key = item.listid ? 'exploded-featured-list-' + item.listid : 'exploded-featured-article-' + item.id;
                        return (
                            <div className={ style.explodedFeatureWrapper } key={ key }>
                                <ExpandedLACard item={ item } />
                            </div>
                        );
                    } ) }
                </Slider>
            </div>
        );
    }
}
ExpandedCardCarousel.propTypes = {
    className: PropTypes.string,
    carousel: PropTypes.object,
};
ExpandedCardCarousel.defaultProps = {
    className: '',
    carousel: {},
};

export default ExpandedCardCarousel;
